import { isProspectInvitePath } from "@fe/utils/is-prospect-invite-path";
import { scrubProspectInviteTokens } from "@fe/utils/scrub-prospect-invite-tokens";
import posthog, { type CaptureResult } from "posthog-js";

export function initPostHog() {
	const token = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
	if (
		!token ||
		posthog.__loaded ||
		isProspectInvitePath(window.location.pathname)
	)
		return;

	posthog.init(token, {
		api_host: "https://eu.i.posthog.com",
		defaults: "2026-01-30",
		before_send: scrubEvent,
		session_recording: {
			maskCapturedNetworkRequestFn: scrubProspectInviteTokens,
		},
	});
}

function scrubEvent(event: CaptureResult | null) {
	if (!event || event.event === "$snapshot") return event;
	return scrubProspectInviteTokens(event);
}
